module.exports = __webpack_public_path__ + "img/borders6.c51f2ac9.png";